import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { clientDepartmentInitialsForAdd, clientDepartmentInitialsForUpdate } from "./interfaces/ClientDepartmentClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountClientDepartmentAsync, updateAccountClientDepartmentAsync, resetSelectedRecordObjectInState } from "./ClientDepartmentSlice";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchAPI from "../../../common/fetchAPI";
import { addAccountLocationAsync } from "../location/LocationSlice";
import { useTranslation } from "react-i18next";
export const ClientDepartmentForm = (props: any) => {

    const { AccountPartyId } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(clientDepartmentInitialsForAdd)
    const { selectedRecord, isLoading } = useAppSelector((state) => state.clientDepartment);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    
    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            console.log('g', Object.keys(clientDepartmentInitialsForUpdate).length);
            const tempObj: any = selectedRecord;
            Object.keys(clientDepartmentInitialsForUpdate).map((item) => {
                if (item === 'AccountPartyId') {
                    return stateItem[item] = AccountPartyId;
                }
                else {
                    return stateItem[item] = tempObj[item];
                }
            })
            
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(clientDepartmentInitialsForAdd);
            setCurrentFieldsData({...clientDepartmentInitialsForAdd,"AccountPartyId":AccountPartyId});
        }
    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        console.log('custom switch:', (e.target.type === 'checkbox' ? e.target.checked : e.target.value))
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountClientDepartmentAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    console.log('originalPromiseResult',originalPromiseResult.StatusCode,originalPromiseResult.ResponseMessage);
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Client Department Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                   // console.log('handleSubmit-updateAccountEmployeeTypeAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
        else {
            dispatch(addAccountClientDepartmentAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Client Department Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    //console.log('handleSubmit-addAccountEmployeeTypeAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
                
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PartyDepartmentCode: yup
                        .string()
                        .label('PartyDepartmentCode')
                        .trim()
                        .required('Department Code is required'),
                    PartyDepartmentName: yup
                        .string()
                        .label('PartyDepartmentName')
                        .trim()
                        .required('Department Name is required')
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className='row'>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label">Department Code</label>
                                                <input type="text" className="form-control" name="PartyDepartmentCode" id='PartyDepartmentCode' value={values.PartyDepartmentCode}
                                                    onChange={handleChange('PartyDepartmentCode')}
                                                    onBlur={() => setFieldTouched('PartyDepartmentCode')}
                                                />
                                                <div>
                                                    {touched.PartyDepartmentCode && errors.PartyDepartmentCode &&
                                                        <p className='errorMsg'>{errors.PartyDepartmentCode as string}</p>
                                                    }
                                                </div>
                                            </div>
                                           
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label">Location</label>
                                                <input type="text" className="form-control" name="PartyDepartmentLocation" id='PartyDepartmentLocation' value={values.PartyDepartmentLocation}
                                                    onChange={handleChange('PartyDepartmentLocation')}
                                                    onBlur={() => setFieldTouched('PartyDepartmentLocation')}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label">Department Name</label>
                                                <input type="text" className="form-control" name="PartyDepartmentName" id='PartyDepartmentName' value={values.PartyDepartmentName}
                                                    onChange={handleChange('PartyDepartmentName')}
                                                    onBlur={() => setFieldTouched('PartyDepartmentName')}
                                                />
                                                <div>
                                                    {touched.PartyDepartmentName && errors.PartyDepartmentName &&
                                                        <p className='errorMsg'>{errors.PartyDepartmentName as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className='card-footer pt-4 '>
                                <div className='d-flex flex-stack float-end'>
                                    <div className='d-flex align-items-center me-2'>
                                        <button
                                            ref={closeButtonRef}
                                            type="button"
                                            className="btn btn-light btn-sm me-2"
                                            // data-bs-dismiss="modal"
                                            id="kt_OffCanvas"
                                            onClick={handleCloseOnClickEvent}
                                        >
                                           {t("Cancel")}
                                        </button>

                                        <button 
                                            type="button" 
                                            className="btn btn-light-primary btn-sm" 
                                            onClick={() => handleSubmit()} disabled={!isValid}
                                            data-kt-element='send'
                                        >
                                            
                                            {/* <i className="ki-duotone ki-plus fs-2">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i> */}
                                            {Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Client Department
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}


{/* <div className="modal fade" tabIndex={-1} id="employeeTypeModal">
<div className="modal-dialog">
    <div className="modal-content">
        <div className="modal-header">
            <h5 className="modal-title">{Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Employee Type</h5>
            <div
                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                data-bs-dismiss="modal"
                aria-label="Close"
            >
                <KTSVG
                    path="/media/icons/duotune/arrows/arr061.svg"
                    className="svg-icon svg-icon-2x"
                />
            </div>
        </div>
        <div className="modal-body">
            <div className="mb-3">
                <label className="form-label">Employee Type</label>
                <input type="text" className="form-control" id='AccountEmployeeType' value={currentFieldsData.AccountEmployeeType} onChange={handleTextChange} />
            </div>
            
            <div className="mb-3">
            <label className="form-label">Is Vendor</label>
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input className="form-check-input h-20px w-30px" type="checkbox" checked={currentFieldsData.IsVendor} id="IsVendor" onChange={handleTextChange} />
                </div>
            </div>
            {Object.keys(selectedRecord).length > 0 ? (
                
                <div className="mb-3" >
                <label className="form-label">Disabled</label>
                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                        <input className="form-check-input h-20px w-30px" type="checkbox" checked={currentFieldsData.IsDisabled} id="IsDisabled" onChange={handleTextChange} />
                    </div>
                </div>
            ) : null}
        </div>
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-light btn-sm"
                data-bs-dismiss="modal"
            >
                Close
            </button>
            <button type="button" className="btn btn-success btn-sm" onClick={handleSubmit}>
                {Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Employee Type
            </button>
        </div>
    </div>
</div>
</div>  */}